import { Component, Inject, OnInit, PLATFORM_ID, ViewChild } from '@angular/core';
import { IndexComponent as IndexSearch01Component } from '../../index-search-01/index/index.component';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonHttpClientService } from '../../../../../../share/service/common-http-client.service';
import { HotKeywordsService } from '../../../../../../share/service/hot-keywords.service';
import { ServerConfigService } from '../../../../../../share/service/server-config.service';
import { GENERATOR_ENV_TOKEN, GeneratorEnv } from '../../../../../generator-env-token';
import { Section } from '../../../../../template-generator/entity/section';
import { TemplateService } from '../../../../../template-generator/service/template.service';
import { SECTION_DATA } from '../../../../service/section-data';
import { ImageUploadModalComponent } from '../../../../component/image-upload-modal/image-upload-modal.component';
import { AppUploadFile } from '../../../../../../share/entity/upload-file';
import { TranslateService } from '@ngx-translate/core';
import { SearchOption } from '../../../../../../data-search/entity/search-options';
import { FORMAT_OPTIONS } from '../../../../../../data-search/entity/itri-filter-search-param';

@Component({
  selector: 'app-index-search-02',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.scss']
})
export class IndexComponent extends IndexSearch01Component implements OnInit {
  @ViewChild('imageUploadModal', {static: false}) imageUploadModal: ImageUploadModalComponent;
  defaultData = {
    title: '國家文化記憶庫',
    subTitle: 'TAIWZN CULTURAL',
    subTitle2: 'MEMORY BANK',
    baners: [],
    mobileBanner: [],
  };
  /** 數位物件類型選項 */
  readonly FORMAT_OPTIONS = FORMAT_OPTIONS;
  /** 綁定的數位物件類型資料 */
  public format: string;

  constructor(
    @Inject(SECTION_DATA) protected section: Section,
    @Inject(GENERATOR_ENV_TOKEN) protected generatorEnv: GeneratorEnv,
    @Inject(PLATFORM_ID) protected platformId: object,
    protected serverConfigService: ServerConfigService,
    protected router: Router,
    protected route: ActivatedRoute,
    protected http: CommonHttpClientService,
    protected hotKeywordsService: HotKeywordsService,
    protected templateService: TemplateService,
    protected translateService: TranslateService,
  ) {
    super(section, generatorEnv, platformId, serverConfigService, router, route, http, hotKeywordsService, templateService, translateService);
  }

  public openImageUploadModal() {
    this.imageUploadModal.open({pc: this.data.baners, mobile: this.data.mobileBanner});
  }

  public onImagesChange(files: {pc: AppUploadFile[], mobile: AppUploadFile[]}) {
    this.data.baners = files.pc;
    this.data.mobileBanner = files.mobile;
  }

  /** 當點擊畫面上的按鈕做查詢(只針對分類和關鍵字) */
  onClickSearch(e?: UIEvent) {
    if (e) { e.preventDefault(); }
    const queryParams: any = {};
    if (this.searchKeyword) {
      queryParams.keyword = this.searchKeyword;
    }
    if (this.format) {
      queryParams.query = JSON.stringify({ format: this.format });
    }
    this.router.navigate([`${this.toHomePath}/datasearch`], {
      queryParams: queryParams,
      queryParamsHandling: 'merge',
    });
  }
}
